<template>
  <section :class="$style.sectionRoot">
    <header :class="$style.sectionHeader">
      Group Configuration
    </header>
    <div :class="$style.sectionContent">
      <div :class="$style.inputRow">
        <InputValidator
          :class="$style.rowSpacing"
          :config="{
            attribute: 'name',
            disabled: groupNameInputDisabled,
            label: 'Name',
            name: 'name',
            validate: 'required',
            value: item.name,
          }"
          @InputValidatorModel="handleInputChange"
        />
        <ManagementGroupInput
          v-if="hasGoogleWorkspaceDirectories"
          :parentType="parentType"
        />
      </div>
      <TextareaValidator
        :class="$style.rowSpacing"
        :config="{
          attribute: 'description',
          label: 'Description',
          name: 'description',
          value: item.description,
        }"
        @InputValidatorModel="handleInputChange"
      />
      <slot />
    </div>
  </section>
</template>
<script>
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';
import ManagementGroupInput from 'client/groups/User/ManagementGroupInput.vue';
import TextareaValidator from 'client/components/FormValidation/TextareaValidator.vue';

export default {
  name: 'GroupConfiguration',

  inject: ['$validator'],

  components: {
    InputValidator,
    ManagementGroupInput,
    TextareaValidator,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  props: {
    groupNameInputDisabled: Boolean,
  },

  computed: {
    hasGoogleWorkspaceDirectories() {
      return (this.item.googleWorkspaceDirectories
            && this.item.googleWorkspaceDirectories.length
            && this.item.managementGroupsEnabled);
    },
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },

  methods: {
    handleInputChange(value, key) {
      this.setItemField({ key, value });
    },
  },
};
</script>
<style module>
@import '../../css/sections.css';
@import '../../css/flex.css';
@import '../../components/FormValidation/css/formFields.css';
</style>
